import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import api from "api";
import PageHeader from "components/layout/page-header/PageHeader";
import styles from "./alterar-senha.module.css";

const FIELDS = [
  { key: "name",     label: "Nome" },
  { key: "username", label: "Usuário" },
  { key: "email",    label: "E-mail" },
  { key: "phone",    label: "Telefone" },
];

const AlterarSenha = ({ token }) => {
  const [profile, setProfile]               = useState({ name: "", username: "", email: "", phone: "" });
  const [loading, setLoading]               = useState(true);
  const [profileError, setProfileError]     = useState(null);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword]       = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [submitting, setSubmitting]         = useState(false);
  const [message, setMessage]               = useState(null);
  const [error, setError]                   = useState(null);

  useEffect(() => {
    if (!token) return;
    const fetchProfile = async () => {
      try {
        setProfileError(null);
        const { data } = await api.get("/profile/me", {
          headers: { Authorization: `Bearer ${token}` }
        });
        setProfile(data);
      } catch (err) {
        setProfileError("Não foi possível carregar seus dados.");
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, [token]);

  const handleSubmit = async e => {
    e.preventDefault();
    setMessage(null);
    setError(null);
    if (newPassword.length < 6) {
      setError("A nova senha deve ter no mínimo 6 caracteres.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("A confirmação da nova senha não confere.");
      return;
    }
    setSubmitting(true);
    try {
      await api.post(
        "/profile/change-password",
        { current_password: currentPassword, new_password: newPassword },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessage("Senha alterada com sucesso!");
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Erro ao alterar senha. Tente novamente.");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className={styles.page}>
        <PageHeader title="Configurações" subtitle="Configure sua conta." accent="Conta" />
        <div className={styles.loadingWrap}>
          <div className={styles.spinner} />
          <span>Carregando seus dados...</span>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <PageHeader title="Configurações" subtitle="Configure sua conta." accent="Conta" />

      {profileError && (
        <div className={styles.alertError} style={{ marginBottom: "1.25rem" }}>
          <i className="fas fa-exclamation-circle" />
          {profileError}
        </div>
      )}

      <div className={styles.grid}>
        {/* Dados cadastrados */}
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <i className={`fas fa-id-card ${styles.cardHeaderIcon}`} />
            <span className={styles.cardHeaderTitle}>Dados cadastrados</span>
          </div>
          <div className={styles.cardBody}>
            {FIELDS.map(({ key, label }) => (
              <div key={key} className={styles.profileField}>
                <span className={styles.fieldLabel}>{label}</span>
                {profile[key]
                  ? <span className={styles.fieldValue}>{profile[key]}</span>
                  : <span className={styles.fieldEmpty}>—</span>
                }
              </div>
            ))}
          </div>
        </div>

        {/* Alterar senha */}
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <i className={`fas fa-lock ${styles.cardHeaderIcon}`} />
            <span className={styles.cardHeaderTitle}>Nova senha</span>
          </div>
          <div className={styles.cardBody}>
            {message && (
              <div className={styles.alertSuccess}>
                <i className="fas fa-check-circle" />
                {message}
              </div>
            )}
            {error && (
              <div className={styles.alertError}>
                <i className="fas fa-exclamation-circle" />
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} noValidate>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Senha atual</label>
                <input
                  type="password"
                  className={styles.input}
                  value={currentPassword}
                  onChange={e => setCurrentPassword(e.target.value)}
                  placeholder="Digite sua senha atual"
                  required
                  autoComplete="current-password"
                />
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Nova senha</label>
                <input
                  type="password"
                  className={styles.input}
                  value={newPassword}
                  onChange={e => setNewPassword(e.target.value)}
                  placeholder="Mínimo 6 caracteres"
                  required
                  minLength={6}
                  autoComplete="new-password"
                />
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Confirmar nova senha</label>
                <input
                  type="password"
                  className={styles.input}
                  value={confirmPassword}
                  onChange={e => setConfirmPassword(e.target.value)}
                  placeholder="Repita a nova senha"
                  required
                  autoComplete="new-password"
                />
              </div>
              <button
                type="submit"
                className={styles.submitBtn}
                disabled={submitting}
              >
                {submitting
                  ? <><div className={styles.spinnerSm} /> Alterando...</>
                  : <><i className="fas fa-key" /> Alterar senha</>
                }
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  token: state.auth.accessToken
});

export default connect(mapStateToProps)(AlterarSenha);
